import baseGoApi from "./baseGoApi";

export const submitLogout = async (): Promise<void> => {
    // Use Go API endpoint: POST /go-api/auth/logout
    await baseGoApi.post('/auth/logout', null, {
        headers: {
            "Content-Type": "application/json",
        },
    });
};